import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import "../../Assets/CSS/EmployeeOffboarding.css";
import { lastOne, LightDark, LighterBold, smallestText, smallLighItalic, smallText } from "../../Assets/CSS/Text";
import axios from "axios";


const BASE_STATUS_STEPS = [
  { title: "Application sent", key: "APPLICATION_SENT" },
  { title: "Approved by HR", key: "HR_APPROVED" },
  { title: "Approved by Manager", key: "MANAGER_APPROVED" },
  { title: "Approved by IT Team", key: "IT_APPROVED" },
  { title: "Approved by Finance Team", key: "FINANCE_APPROVED" },
  { title: "Off-boarding Completed", key: "COMPLETED" },
];

const OffboardingEmployeeStatus = () => {
  const [statusSteps, setStatusSteps] = useState([]);
  const [offboardingDetails, setOffboardingDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [requestId, setRequestId] = useState(null);


  const fetchMyRequest = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/my-requests`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*"
          },
          withCredentials: true // if cookies are used
        }
      );

      console.log("Login Request", response.data);
      if (response.status === 200) {
        const reqId = response.data?.[0]?.requestId;
        setRequestId(reqId || "");

        // const reqId = response.data?.data?.requestId; // 👈 adjust path if needed
        // setRequestId(reqId); // save in another variable

        console.log("Request ID:", reqId);
      }

    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      setError("Failed to load offboarding status");
    } finally {
      setLoading(false);
    }
  };
  const fetchStatus = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.get(

        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/${requestId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*"
          },
          withCredentials: true // if cookies are used
        }

      );

      // ✅ adjust keys as per backend response
      // if (response.status === 200) {
      //   console.log("Login Request", response)
      // }
      // // setStatusSteps(response.data?.statusSteps || []);
      // // setOffboardingDetails(response.data?.offboardingDetails || {});
      if (response.status === 200) {
        const data = response.data;

        setOffboardingDetails(data); // store full object

        // 🔥 THIS IS MAIN LINE
        // const updatedSteps = mapStatusSteps(data);
        // setStatusSteps(updatedSteps);
        const updatedSteps = mapStatusSteps(data);
        setStatusSteps(updatedSteps);

      }
    } catch (err) {
      console.error(err);
      setError("Failed to load offboarding status");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyRequest();
  }, []);

  useEffect(() => {
    if (requestId) fetchStatus();
  }, [requestId]);



  const mapStatusSteps = (data) => {
    const approvedRoles = data.approvals?.map(a => a.approverRole) || [];

    return BASE_STATUS_STEPS.map(step => {
      let completed = false;

      switch (step.key) {
        case "APPLICATION_SENT":
          completed = true;
          break;
        case "HR_APPROVED":
          completed = approvedRoles.includes("ROLE_HR");
          break;
        case "MANAGER_APPROVED":
          completed = approvedRoles.includes("ROLE_MANAGER");
          break;

        case "IT_APPROVED":
          completed = approvedRoles.includes("ROLE_IT_MANAGER");
          break;

        case "FINANCE_APPROVED":
          completed = approvedRoles.includes("ROLE_FINANCE");
          break;

        case "COMPLETED":
          completed = data.status === "COMPLETED";
          break;

        default:
          completed = false;
      }

      return {
        ...step,
        status: completed ? "completed" : "pending",
      };
    });
  };

  return (
    <>


      {/* Offboarding Details */}
      <div className="info-card">
        <h6 className="section-title">Offboarding Details</h6>

        <div className="row">
          <div className="col-md-4">
            <div className="info-box">
              <small>Last Working Day</small>
              <p className="psmall">{offboardingDetails.lastWorkingDay}</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="info-box">
              <small>Offboarding Type</small>
              <p className="psmall">{offboardingDetails.offboardingType}</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="info-box">
              <small>Status</small>
              <p className="psmall pProgress"
                style={{ width: '100%' }}>
                {offboardingDetails?.status
                  ?.replace(/_/g, " ")
                  .toLowerCase()
                  .replace(/\b\w/g, c => c.toUpperCase())}
              </p>

            </div>
          </div>
        </div>
      </div>
      {/* Status Alert */}
      <div className="info-card mt-4">
        <div>
          <p style={lastOne}>Status </p>

          {/* < div className=" position-relative ps-3">
            <div
              className="position-absolute top-0 bottom-0"
              style={{
                width: "2px",
                backgroundColor: "#E0E0E0",
                left: "4px",
              }}
            ></div>

            {statusSteps.length > 0 ? (
              statusSteps.map((item, index) => (
                <div
                  key={index}
                  className="timeline-item d-flex flex-wrap align-items-start gap-2 mb-3 position-relative "
                >
                  <div
                    className="position-absolute rounded-circle"
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "#A1A1A1",
                      left: "-16px",
                      top: "8px",
                    }}
                  ></div>
                  <div className='role-row d-flex justify-content-between align-items-center flex-wrap'>

                    <h6
                      className="mb-0"
                      style={{ ...LighterBold, minWidth: "250px" }}
                    >
                      {item.title || "N/A"}
                    </h6>

                    <div>

                      <h6 className="fw-semibold mb-0" style={smallText}>
                        {item.date
                          ?.split("Admin")[0]
                          .trim()
                          .replace(/\b\w/g, char => char.toUpperCase()) || "N/A"}
                      </h6>



                    </div>


                  </div>



                </div>
              ))
            ) : (
              <p className="text-muted ps-4">No records found.</p>
            )}
          </div> */}

          <div className="position-relative ps-2">
            {/* Vertical Line */}
            <div
              className="position-absolute  "
              style={{
                width: "2px",
                top: '10px',
                bottom: '13px',
                backgroundColor: "#E0E0E0",
                left: "10px",
              }}
            />

            {statusSteps.length > 0 ? (
              statusSteps.map((item, index) => (

                <div
                  key={index}
                  className="d-flex align-items-start mb-4 position-relative"
                >
                  {/* DOT / ICON */}
                  <div
                    className="position-absolute d-flex align-items-center justify-content-center"
                    style={{
                      width: item.status === "completed" ? "20px" : "10px",
                      height: item.status === "completed" ? "20px" : "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        item.status === "completed" ? "none" : "#D9D9D9",
                      left: "4px",                    // 🔒 vertical line X
                      top: "1px",
                      transform: "translateX(-50%)",  // 🔥 always -50%
                      zIndex: 2,
                    }}
                  >
                    {item.status === "completed" && (
                      <Icon icon="weui:done2-filled" color="#22c55e"
                        style={{
                          height: '16px',
                          width: '16px'
                        }}
                      />
                    )}
                  </div>

                  {/* CONTENT */}
                  <div className="d-flex col-md-6  ps-4 pb-1" >
                    <div>
                      <div style={LightDark}>{item.title}</div>

                      {item.remark && (
                        <small style={smallLighItalic}>
                          {item.remark}
                        </small>
                      )}
                    </div>

                    {/* DATE */}

                  </div>
                  <div className="col-md-6">
                    <small className="text-muted">
                      {item.date || ""}
                    </small>
                  </div>
                </div>

              ))
            ) : (
              <p className="text-muted ps-4">No records found.</p>
            )}
          </div >

        </div >
      </div >
      {/* Help Section */}
      < div className="info-card" >
        <h6 className="section-title">Need Help?</h6>
        <p className="help-text">
          For any questions or concerns regarding your offboarding
          process, please contact:
        </p>

        <div className="help-box">
          <p className="hrdpt">HR Department</p>
          <p className="emailPhone">Email: hr@company.com</p>
          <p className="emailPhone">Phone: +1 (555) 123-4567</p>
        </div>
      </div >
    </>
  )
};

export default OffboardingEmployeeStatus;